import { ArcadeIconNames } from './ArcadeIcon'
import { ArcadePaymentIconNames } from './ArcadePaymentIcon'
import { IconNames as BronteIconNames } from './Icon'
import { BRONTE_TO_ARCADE_ICONS_MAPPING_GENERATED, OptionalRecord } from './iconMappings.generated'
import { PaymentIconNames } from './PaymentIcon'
import { BRONTE_TO_ARCADE_PAYMENT_ICONS_MAPPING_GENERATED } from './paymentIconMappings.generated'

export const BRONTE_TO_ARCADE_ICONS_MAPPING: OptionalRecord<BronteIconNames, ArcadeIconNames> = {
  ...BRONTE_TO_ARCADE_ICONS_MAPPING_GENERATED,
} as const

export const BRONTE_TO_ARCADE_PAYMENT_ICONS_MAPPING: OptionalRecord<PaymentIconNames, ArcadePaymentIconNames> = {
  ...BRONTE_TO_ARCADE_PAYMENT_ICONS_MAPPING_GENERATED,
} as const
